export enum ApplicationStatus {
  "None" = 0,
  "Incomplete" = 1,
  "Pending Requirements" = 2,
  "For HSO Processing" = 3,
  "Specimen For HSO Processing" = 4,
  "XRay For HSO Processing" = 5,
  "For Payment Lab Fee" = 6,
  "For Doctor's Evaluation" = 8,
  "For Compliance" = 9,
  "Under Evaluation by CHSO: Sanitation Division" = 10,
  "Under Evaluation by BCPO" = 19,
  "Parallel Evaluation by CHSO and BCPO" = 25,
  "For Releasing" = 21,
}
